/**
 * Reflects the data describet by the data_type.go file
 * NEEDS TO BE UPDATED AND MAINTAINED IN SYNC WITH THE ORIGINAL GO ENTITY
 */
export enum DataTypeModelKey {
    soundPressureLevel = "sound_pressure_level",
    soundPressureLevelC = "sound_pressure_level_c",
    soundPressureLevel1Minute = "sound_pressure_level_1m",
    soundPressureLevel1MinuteSensor2 = "sound_pressure_level_1m_sensor_2",
    soundPressureLevelC1Minute = "sound_pressure_level_c_1m",
    soundPressureLevelCMinusA = "sound_pressure_level_c_minus_a",
    rolling5s = "rolling_5s",
    rolling5sC = "rolling_5s_c",
    rolling5 = "rolling_5",
    rolling5C = "rolling_5_c",
    rolling30 = "rolling_30",
    rolling30C = "rolling_30_c",
    battery = "battery",
    overload = "overload",
    underrange = "underrange",
    powerSupplyStatus = "power_supply_status",
    wifiSignalLevel = "wifi_signal_level",
    cellullarSignalLevel = "cellullar_signal_level",
    temperature = "temperature",
    spectrum13Octave = "spectrum_13_octave",
    spectrum13Octave1Minute = "spectrum_13_octave_1m",
    onlineDevices = "online_devices",
    eventStream = "event_stream",
    freeStorage = "free_storage",
}

export interface IDataType<T> {
    soundPressureLevel?: T;
    soundPressureLevelC?: T;
    soundPressureLevel1Minute?: T;
    soundPressureLevel1MinuteSensor2?: T;
    soundPressureLevelC1Minute?: T;
    soundPressureLevelCMinusA?: T;
    rolling5s?: T;
    rolling5sC?: T;
    rolling5?: T;
    rolling5C?: T;
    rolling30?: T;
    rolling30C?: T;
    battery?: T;
    overload?: T;
    underrange?: T;
    powerSupplyStatus?: T;
    wifiSignalLevel?: T;
    cellullarSignalLevel?: T;
    temperature?: T;
    spectrum13Octave?: T;
    spectrum13Octave1Minute?: T;
    freeStorage?: T;
}

const retiredDataTypeModelKeys = new Set<string>(["30_minutes"]);

export function isRetiredDataTypeModelKey(key: unknown): boolean {
    return typeof key === "string" && retiredDataTypeModelKeys.has(key);
}
